import {
  Component,
  HostListener,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
  OnDestroy,
} from "@angular/core";
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from "subsink";

import { ZoneComponent } from "@/shared-module/components";
import { DialogService, ConfigurationService } from "@/shared-module/services";
import { Configuration, RankIndicesDatasource } from "@/shared-module/models";

@Component({
  selector: "app-rank-indices",
  templateUrl: "rank-indices.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .green-tooltip .tooltip-inner {
        background-color: #00de9a !important;
      }
      .green-tooltip .arrow::before {
        border-bottom-color: #00de9a !important;
      }
      .red-tooltip .tooltip-inner {
        background-color: #ff6748 !important;
      }
      .red-tooltip .arrow::before {
        border-bottom-color: #ff6748 !important;
      }
    `,
  ],
})
export class RankIndicesComponent implements OnInit, ZoneComponent, OnDestroy {
  @Input() data: RankIndicesDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;
  @ViewChildren(NgbTooltip) tooltips: QueryList<NgbTooltip>;
  cssColor: string;
  subs = new SubSink();
  highContrast: boolean;

  constructor(
    private configurationService: ConfigurationService,
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        thisObject.highContrast = c.highContrast;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  @HostListener('document:keydown.escape')
  closeTooltips(): void {
    this.tooltips?.forEach(t => t.close());
  }

  zoom(zoomInfo) {
    this.dialogService.setZoomInfo(zoomInfo);
  }
}
